<template>
  <v-card flat>
    <v-card-title class="justify-end">
      <!-- <v-btn
        class="rounded-lg"
        color="success"
        depressed
        large
        target="_blank"
        to="/user/old-transactions"
      >
        {{ $t('newUserTransactions.oldWallet') }}
      </v-btn> -->
    </v-card-title>

    <v-row class="pa-4" no-gutters>
      <v-col class="pa-2" cols="12">
        <vue-table
          :data="data"
          :headers="headers"
          :loading.sync="loading"
          @change="onPagination"
          :props.sync="tableProps"
        >
          <template v-slot:filters="{ props, perPage }">
            <v-row no-gutters>
              <v-col class="pa-2" cols="12" lg="1" md="2">
                <v-select
                  v-model="props.length"
                  :items="perPage"
                  class="rounded-lg"
                  dense
                  hide-details
                  :label="$t('newUserTransactions.perPage')"
                  outlined
                />
              </v-col>
              <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-text-field
                v-model="searchInput"
                @keyup.enter="executeSearch"
                @click:append="executeSearch"
                @click:clear="clearSearch"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                :label="$t('newUserTransactions.search')"
                outlined
              />
            </v-col>
              <v-col class="pa-2" cols="12" lg="4" md="6">
                <v-select
                  v-model="props.type"
                  :items="types"
                  :menu-props="{ offsetY: true }"
                  class="rounded-lg"
                  clearable
                  dense
                  :label="$t('newUserTransactions.transactionType')"
                  outlined
                />
              </v-col>

              <v-col class="pa-2" cols="12" lg="4" md="6">
                <v-select
                  v-model="props.serviceId"
                  :items="services"
                  :menu-props="{ offsetY: true }"
                  class="rounded-lg"
                  clearable
                  dense
                  :label="$t('newUserTransactions.service')"
                  outlined
                />
              </v-col>

              <v-col class="pa-2" cols="12" lg="4" md="6">
                <custom-date-picker
                  v-model="props.createdAt_start"
                  append-icon="mdi-calendar-range"
                  dense
                  format="YYYY-MM-DD"
                  input-class="start-date"
                  :label="$t('newUserTransactions.dateFrom')"
                  nullable
                  outlined
                  type="date"
                  wrapper-class="rounded-lg"
                />
              </v-col>

              <v-col class="pa-2" cols="12" lg="4" md="6">
                <custom-date-picker
                  v-model="props.createdAt_end"
                  append-icon="mdi-calendar-range"
                  dense
                  format="YYYY-MM-DD"
                  input-class="end-date"
                  :label="$t('newUserTransactions.dateTo')"
                  nullable
                  outlined
                  type="date"
                  wrapper-class="rounded-lg"
                />
              </v-col>
                 <v-col class="pa-2 d-flex" cols="12" lg="3" md="4" sm="6" v-if="user.official_type === 'official'">
              <v-btn class="btn-report my-0" @click="factor"
                >ایجاد فاکتور</v-btn
              >
            </v-col>

            </v-row>
          </template>

          <template v-slot:index="{ item }">
            {{
              use_lang(item.index + 1 + (data.current_page - 1) * data.per_page)
            }}
          </template>

          <template v-slot:amount="{ item }">
            <v-chip
              :color="item.type === 'withdraw' ? '#F64E60' : 'rgb(27,197,189)'"
              dark
              label
              small
            >
              {{ use_lang(price(item.amount.$numberDecimal)) }}
            </v-chip>
          </template>

          <template v-slot:time="{ item }">
            <div class="text-nowrap">
              {{ use_lang($options.filters.onlyTime(item.createdAt)) }}
            </div>
          </template>

          <template v-slot:createdAt="{ item }">
            <div class="text-nowrap">
              {{ use_lang($options.filters.onlyDate(item.createdAt)) }}
            </div>
          </template>

          <template v-slot:description="{ item }">
            <div
              class="d-flex align-center flex-nowrap flex-row"
              style="gap: 8px"
            >
              <div class="link-wrapper" v-html="item.description"></div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="flex-shrink: 0"
                    class="me-2"
                    depressed
                    fab
                    color="primary"
                    icon
                    x-small
                    v-if="item?.meta?.imageLink"
                    @click="
                      pngimg = item?.meta?.imageLink;
                      mediaDialog = true;
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-image</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("newUserTransactions.showReceipt") }}</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:type="{ item }">
            <v-chip
              v-if="!!item.type"
              :color="$options.filters.transactionType(item.type).color"
              label
              outlined
              small
            >
              {{ $t(`newUserTransactions.transactionTypes.${item.type}`) }}
            </v-chip>
          </template>

          <template v-slot:product_description="{ item }">
            <v-chip
              v-if="!!item.product && !!item.product.description"
              color="#181c32"
              dark
              label
              small
            >
              {{ item.product.description }}
            </v-chip>
          </template>

          <template v-slot:serviceId="{ item }">
            <v-chip color="#6993ff" dark label small>
              {{ $options.filters.serviceTypeNumber(item.serviceId) }}
            </v-chip>
          </template>

          <template v-slot:balanceAfter="{ item }">
            {{ use_lang(price(item.balanceAfter.$numberDecimal)) }}
          </template>
        </vue-table>
      </v-col>
    </v-row>
    <custom-popup
      v-model="mediaDialog"
      :cons="{ title: $t('newUserTransactions.depositReceipt') }"
      width="720"
      hide-confirm
      class="popup"
    >
      <div class="cover-dialog">
        <div class="zoom-controls">
          <v-btn class="btnZoom" @click="zoomIn" icon>
            <v-icon>mdi-magnify-plus</v-icon>
          </v-btn>
          <v-btn class="btnZoom" @click="zoomOut" icon>
            <v-icon>mdi-magnify-minus</v-icon>
          </v-btn>
          <v-btn class="btnZoom" @click="resetZoom" icon>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <div class="text-center pa-4 conteiner-zoom">
          <v-img
            :src="pngimg"
            :alt="$t('newUserTransactions.depositReceipt')"
            width="100%"
            height="100%"
            :lazy-src="pngimg"
            :style="imageStyle"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  v-if="loadingimage"
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
      </div>
    </custom-popup>
    <custom-popup
    v-model="profileDialog"
    :cons="{ title: 'تکمیل حساب کاربری', icon: 'account-alert-outline' }"
    max-width="500"
    hide-confirm
    class="popup"
  >
    <v-card flat class="pa-2">
      <v-card-text class="text-center pt-6 pb-2">
        <!-- آیکون و متن اصلی -->
        <v-icon color="warning" size="64" class="mb-4">mdi-shield-account-outline</v-icon>
        
        <div class="text-h6 font-weight-bold mb-3 text--primary">
          اطلاعات کاربری شما ناقص است!
        </div>
        
        <div class="text-body-1 text--secondary mb-6">
          برای مشاهده و صدور فاکتور رسمی، ابتدا باید اطلاعات حساب کاربری خود را تکمیل نمایید.
        </div>

      </v-card-text>

      <!-- دکمه‌های عملیاتی -->
      <v-card-actions class="d-flex justify-space-between pb-4 px-6 mt-4">
        <v-btn
          
          
          class="rounded-lg px-2 btn-delete"
          @click="profileDialog = false"
        >
          <v-icon right class="ml-2">mdi-close</v-icon>
          انصراف
        </v-btn>

        <v-btn
          class="rounded-lg px-2 btn-get-code"
          elevation="2"
          @click="goToProfile"
        >
          <v-icon right class="ml-2">mdi-account-edit</v-icon>
          تکمیل اطلاعات
        </v-btn>
      </v-card-actions>
    </v-card>
  </custom-popup>

  </v-card>
</template>

<script>
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import { icon } from "leaflet";
import {mapGetters} from "vuex";
export default {
  name: "newUserTransactions",
  components: { CustomDatePicker },

  data() {
    return {
      profileDialog: false,
      searchInput:"",
      pngimg: null,
      mediaDialog: false,
      types: [
        // { value: "online", text: "" },
        { value: "adminCharge", text: "" },
        { value: "refund", text: "" },
        { value: "agency", text: "", disabled: true },
        { value: "withdraw", text: "" },
        { value: "charge", text: "" },
      ],
      loadingimage: false,
      data: [],
      dialog: false,
      editCons: {
        title: "",
        buttons: [
          { text: "", type: "submit", handler: this.refundTransaction },
        ],
      },
      loading: false,
      headers: [
        { text: "", value: "index", align: "center", sortable: false },
        { text: "", value: "uniqueId", align: "center", sortable: false },
        { text: "", value: "amount", align: "center", sortable: false },
        { text: "", value: "time", align: "center", sortable: false },
        { text: "", value: "createdAt", align: "center", sortable: false },
        { text: "", value: "description", align: "center", sortable: false },
        { text: "", value: "type", align: "center", sortable: false },
        {
          text: "",
          value: "product_description",
          align: "center",
          sortable: false,
        },
        { text: "", value: "serviceId", align: "center", sortable: false },
        { text: "", value: "balanceAfter", align: "center", sortable: false },
      ],
      services: [],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
    };
  },
  computed: {
    ...mapGetters('ribbon', ['user']),
    imageStyle() {
      return {
        transform: `scale(${this.scale})`,
        transition: "transform 0.3s ease-in-out",
        width: "800px",
        height: "auto",
      };
    },
  },
  created() {
    this.getToken();
    this.updateTranslations();
    this.getTransactions();
  },
  watch: {
    "$i18n.locale": function () {
      this.updateTranslations();
      this.$forceUpdate();
    },
    immediate: true,
    deep: true,
  },

  methods: {
        getToken(){
       this.requestApiGet("user/jwt").then(({data})=>{
        this.tableProps.token = data.data.token;
        
      }).catch(({response})=>{
        this.$toast.error("فرایند ساخت فاکتور با مشکل روبرو شده مجدد سعی کنید")
      }) .finally(() => {});
    },

        encodeQueryData(data) {
      const ret = [];
      for (const d in data) {
        if (!data[d]) continue;
        else if (typeof data[d] === "object") data[d] = data[d].join(",");

        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
      }
      return ret.join("&");
    },
  goToProfile() {
    this.profileDialog = false;
    this.$router.push('/profile/edit-personal');
  },
factor() {
   const { name, lastName, nid } = this.user;
    
    if (!name || !lastName || !nid) {
      this.profileDialog = true;
      return;
    }

      this.requestApiGet("user/jwt").then(({data})=>{
    this.tableProps.token = data.data.token;
        let { productId, type, dateFrom, toDate, userId, token,description } = this.tableProps;      
      let user_id = Array.isArray(userId) ? userId[0] : (userId ? String(userId).split(',')[0] : '');
  const link =
    `${this.$coreApi2}/admin/newWallet/generateFactor?` +
    this.encodeQueryData({
      product: productId, 
      type,
      dateFrom,
      toDate,
      userId:user_id,
      token,
      desc:description
    });
  window.open(link, "_blank");
      }).catch(({response})=>{
        this.$toast.error("فرایند ساخت توکن با مشکل روبرو شده مجدد سعی کنید")
      }) .finally(() => {});

      
  },
    updateTranslations() {
      this.types = [
        // {
        //   value: "online",
        //   text: this.$t("newUserTransactions.transactionTypes.online"),
        // },
      {
          value: "adminCharge",
          text: this.$t("newUserTransactions.transactionTypes.admin"),
        },
        {
          value: "refund",
          text: this.$t("newUserTransactions.transactionTypes.refund"),
        },
        {
          value: "agency",
          text: this.$t("newUserTransactions.transactionTypes.agency"),
          disabled: true,
        },
        {
          value: "withdraw",
          text: this.$t("newUserTransactions.transactionTypes.withdraw"),
        },
        {       

          value: "charge",
          text: this.$t("newUserTransactions.transactionTypes.deposit"),
        },
      ];

      this.headers = [
        {
          text: this.$t("newUserTransactions.row"),
          value: "index",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.uniqueId"),
          value: "uniqueId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.amount"),
          value: "amount",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.time"),
          value: "time",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.createdAt"),
          value: "createdAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.description"),
          value: "description",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.type"),
          value: "type",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.product_description"),
          value: "product_description",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.serviceId"),
          value: "serviceId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("newUserTransactions.balanceAfter"),
          value: "balanceAfter",
          align: "center",
          sortable: false,
        },
      ];

      this.editCons.title = this.$t("newUserTransactions.depositReceipt");
    },
    onImageError() {
      this.imageloading = false;
      this.$toast.error(this.$t("newUserTransactions.error.imageLoad"));
    },
    onImageLoad() {
      this.imageloading = false;
    },
    zoomIn() {
      this.scale += 0.1;
    },
    zoomOut() {
      if (this.scale > 0.2) this.scale -= 0.1;
    },
    resetZoom() {
      this.scale = 1;
    },
    getDate(val, type = "date") {
      let moment = require("moment-jalaali");

      const date = new Date();
      date.setTime(val);

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month}-${day}`;
      const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

      if (type === "date") return moment(formattedDate).format("jYYYY-jM-jD");

      let t = formattedDate + " " + time;
      return moment(t).format("HH:mm:ss");
    },
    getTransactions(params = this.tableProps) {
      this.loading = true;

      this.requestApiGet("newWallet/myTransactions", params)
        .then(({ data }) => {
          this.data = data.data;
          !this.services?.length && this.getServices();
        })
        .catch(({ response }) =>
          console.log("failed to get user transactions: ", response)
        )
        .finally(() => (this.loading = false));
    },
    getServices() {
      this.requestApiGet("getServices").then(({ data }) => {
        this.services = data.services.map((item) => {
          return {
            text: this.$options.filters.serviceTypeNumber(item.id),
            value: item.id,
          };
        });
      });
    },
    executeSearch() {
      this.tableProps.search = this.searchInput;
      this.getTransactions();
    },
    clearSearch() {
      this.searchInput="";
      this.tableProps.search = "";
      this.$nextTick(() => {
        this.getTransactions();
      });
    },
    clearType() {
      this.tableProps.type = "";
      this.$nextTick(() => {
        this.getTransactions();
      });
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getTransactions(props);
    },
  },
};
</script>

<style scoped>
.desc-html-wrapper >>> a {
  padding: 2px 4px;
  margin: 2px;
  display: inline-block;
  background-color: skyblue;
  border-radius: 4px;
  transition: background-color 0.1s ease-in;
}

.desc-html-wrapper >>> a:hover {
  background-color: #2ea0ec;
}

.link-wrapper >>> a {
  padding: 2px 4px;
  margin: 0 4px;
  background-color: #0d8ddc;
  border-radius: 4px;
  color: white;
  transition: background-color 0.1s ease-out;
}

.link-wrapper >>> a:hover {
  background-color: #2ea0ec;
}
.cover {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.cursor-pointer:active,
.cursor-ponter:hover {
  scale: 1.2;
}
.cover-dialog {
  position: relative;
  display: flex;
  flex-direction: row;
  column-gap: 5px;
  width: 700px;
  height: 700px;
  overflow: hidden;
}
.zoom-controls {
  left: 5px;
  right: 5px;
  position: absolute;
  height: 50px;
  width: 150px;
  justify-content: center;
  align-items: center;
}
.btnZoom {
  font-size: 18px;
  flex: 0 0 auto;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  background-color: white;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.151),
    0px -4px 15px rgba(0, 0, 0, 0.151);
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
}
.btnZoom:hover,
.btnZoom:active {
  background-color: #f0f0f0;
  box-shadow: 0px 5px 17px rgba(0, 0, 0, 0.251),
    0px -5px 17px rgba(0, 0, 0, 0.251);
}
.conteiner-zoom {
  overflow: hidden;
}
.zoom-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  z-index: 10;
}
</style>
